import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { Box } from '@mui/material';
import { ReceiptRenderer } from './RecursiveSummaryReceipt';
import { SCUILoadingLinear, SCUIButton } from '../../../atomic/atoms';

import TimeHelper from '../../../utils/time';
import { SummaryQuery } from '../../../services/query';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export const SummaryDetail = ({ summary, setSummary }: any) => {
    const [isLoading, setIsLoading] = useState(false);
    const [summaryDetail, setSummaryDetail] = useState<any>([]);

    const { t } = useTranslation();

    const getSummaryDetail = () => {
        setIsLoading(true);
        SummaryQuery.GetSummaryById({
            paymentConsolidationId: summary.paymentConsolidationId,
        })
            .then((res: any) => {
                if (res) {
                    setSummaryDetail(res);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                setIsLoading(false);
                Swal.fire(t('general.anErrorOccured', '', 'error'));
            });
    };

    useEffect(() => {
        if (summary?.paymentConsolidationId) {
            getSummaryDetail();
        }
    }, [summary?.paymentConsolidationId]);

    useEffect(() => {
        if (!summary?.paymentConsolidationId) {
            setSummaryDetail([]);
        }
    }, [summary?.paymentConsolidationId]);

    return summary?.paymentConsolidationId ? (
        <>
            {isLoading && (
                <Box sx={{ margin: '24px 0 24px 0 ' }}>
                    <SCUILoadingLinear display={isLoading} />
                </Box>
            )}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'left',
                    marginBottom: '12px',
                    marginTop: '12px',
                    '& .sc-btn__text': {
                        padding: '8px !important',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                }}
            >
                <SCUIButton
                    text={t('general.back')}
                    type="primary"
                    sizeType="fixed"
                    buttonType="button"
                    size={'m'}
                    showStartIcon
                    startIcon={<ArrowBackIosNewIcon sx={{ fontSize: '16px', color: '#fff' }} />}
                    onClick={() => {
                        setSummaryDetail([]);
                        setSummary({});
                    }}
                />
            </Box>
            <Box sx={{ padding: '24px', mx: 'auto' }}>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '24px',
                        flexDirection: 'column',
                        border: '1px solid #a0a0a0',
                        borderRadius: '8px',
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
                        <p style={{ fontSize: '14px', fontWeight: '600' }}>{t('summary.summaryDate')}:</p>
                        <p style={{ fontSize: '14px', fontWeight: '500', marginLeft: '8px' }}>
                            {TimeHelper.formatDate(summary?.periodBeginDate)} -{' '}
                            {TimeHelper.formatDate(summary?.periodEndDate)}
                        </p>
                    </Box>
                    {summaryDetail && (
                        <ReceiptRenderer
                            data={summaryDetail}
                            summaryInfo={summary}
                            getSummaryDetail={getSummaryDetail}
                            setIsLoading={setIsLoading}
                            setSummary={setSummary}
                        />
                    )}
                </Box>
            </Box>
        </>
    ) : (
        <></>
    );
};
